import './style/topNav.css';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { LogoutAsync, SelectCurrentUser, SelectIsLogged, setLoginModalShow } from '../features/authentication/authenticationSlice';
import { Link } from 'react-router-dom';
import { useState } from 'react';

const TopNav = () => {
    const dispatch = useAppDispatch();
    const isLogged = useAppSelector(SelectIsLogged);
    const currentUser = useAppSelector(SelectCurrentUser);
    const [showMenu, setShowMenu] = useState(false);

    const displayName = isLogged && currentUser?.name ? currentUser.name : "אורח";

    return (
        <nav className='navbar' id='navMenu'>
            <button className="hamburger" id="hamburgerBtn" onClick={() => setShowMenu(!showMenu)}>☰</button>
            <ul className={`topnav ${showMenu && "open"}`}>
                <li><Link to={'/'}>מערכת הרשמה לאימונים</Link></li>
                {isLogged ? (
                    <>
                        <li><Link to={'addWorkout'} onClick={() => setShowMenu(false)}>הוסף אימון</Link></li>
                        <li><Link to={'manageWorkout'} onClick={() => setShowMenu(false)}>נהל אימונים</Link></li>
                        <li><Link to={'manageInstructor'} onClick={() => setShowMenu(false)}>נהל מדריכים</Link></li>
                        <li><Link to={'manageWorkoutTypes'} onClick={() => setShowMenu(false)}>נהל סוגי אימונים</Link></li>
                        <li><Link to={'directory'} onClick={() => setShowMenu(false)}>מאגר מתאמנים</Link></li>
                        <li className='push-left'><Link to={'manageUsers'} onClick={() => setShowMenu(false)}>ניהול משתמשים</Link></li>
                        <li>
                            <Link to={''} onClick={() => {
                                setShowMenu(false);
                                dispatch(LogoutAsync());
                            }}>
                                שלום {displayName}, התנתק/י&ensp;
                            </Link>
                        </li>
                    </>
                ) : (
                    <>
                        <li><Link to={'/'}>דף הבית</Link></li>
                        <li className="push-left">
                            <Link to={{}} onClick={() => {
                                setShowMenu(false);
                                dispatch(setLoginModalShow(true));
                            }}>
                                שלום {displayName}, התחבר/י&ensp;
                            </Link>
                        </li>
                    </>
                )}
            </ul>
        </nav>
    );
};

export default TopNav;